module.exports = __webpack_public_path__ + "img/ge-logo.43ccb99c.png";